import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import { NextPage } from "next";
import DiscussDetailPage from "components/pages/discuss/Detail";
import { getServerSession } from "next-auth";
import { authOptions } from "pages/api/auth/[...nextauth]";
import { QueryClient, dehydrate } from "@tanstack/react-query";

interface Props {
  isAdminUser: boolean;
  isMobile: boolean;
  isLoginUser: boolean;
  email?: string;
  discussId: string;
  slug: string;
}

const DiscussDetail: NextPage<Props> = ({
  isAdminUser,
  isMobile,
  isLoginUser,
  email,
  discussId,
  slug,
}) => {
  return (
    <DiscussDetailPage
      isAdminUser={isAdminUser}
      isMobile={isMobile}
      isLoginUser={isLoginUser}
      email={email}
      discussId={discussId}
      slug={slug}
    />
  );
};
export default DiscussDetail;

export async function getServerSideProps({
  locale,
  req,
  res,
  params,
}: GetServerSidePropsContext) {
  const session: any = await getServerSession(req, res, authOptions);
  let isAdminUser = false;
  let isLoginUser = false;

  if (
    session?.user?.email &&
    (session?.user?.email.includes("@juroinstruments.com") ||
      session?.user?.email.includes("@gne.ai"))
  ) {
    isAdminUser = true;
  }
  if (session?.user?.email) {
    isLoginUser = true;
  }

  // 테스트 용도
  const currentDomain = req.headers.host || "";
  const IS_LOCAL = process.env.NODE_ENV === "development";
  if (IS_LOCAL || currentDomain?.includes("test.riskweather.io"))
    isAdminUser = true;

  // TanStack Query client 생성 및 프리패치
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        refetchOnWindowFocus: false,
      },
    },
  });

  const slugId = params?.slugId as string;
  const splited = slugId?.split("-");
  let discussId = "";
  let slug = "";
  if (splited?.length === 1) {
    discussId = splited[0];
  } else {
    discussId = splited?.pop() as string;
    slug = splited?.slice(0, -1).join("-");
  }

  if (discussId && !isNaN(Number(discussId))) {
    try {
      // 토론 상세 데이터 프리패치
      const queryKey = [
        "discuss",
        "detail",
        Number(discussId),
        session?.user?.email || null,
      ];
      {
        /**
        url_slug 체크
        */
      }
      const baseUrl = process.env.NEXTAUTH_URL || `http://${req.headers.host}`;
      const url = session?.user?.email
        ? `${baseUrl}/api/discuss/${discussId}?email=${session?.user?.email}`
        : `${baseUrl}/api/discuss/${discussId}`;

      await queryClient.prefetchQuery({
        queryKey,
        queryFn: async () => {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error("토론 데이터를 가져오는데 실패했습니다");
          }
          return response.json();
        },
      });
    } catch (error) {
      console.error("토론 데이터 프리패치 실패:", error);
    }
  }

  // dehydrate 전에 undefined 값 확인 및 정리
  const dehydratedState = dehydrate(queryClient);

  // undefined 값을 null로 변환하는 함수
  const cleanDehydratedState = JSON.parse(
    JSON.stringify(dehydratedState, (key, value) => {
      return value === undefined ? null : value;
    })
  );

  return {
    props: {
      discussId,
      slug,
      hasMetaData: true,
      isAdminUser,
      isLoginUser,
      dehydratedState: cleanDehydratedState,
      email: session?.user?.email || null,
      // BriefingAd 가 main 네임스페이스를 쓴다
      ...(await serverSideTranslations(locale as string, ["discuss", "main"])),
    },
  };
}
